export const ParticipantType = {
	HOME:  'home',
	GUEST: 'guest',
};
